
import {
  defineComponent,
  computed,
} from 'vue';

import Slider from '@vueform/slider';

export default defineComponent({
  components: {
    Slider,
  },

  props: {
    modelValue: {},
    min: {
      type: Number,
      required: false,
      default: () => 0,
    },
    max: {
      type: Number,
      required: false,
      default: () => 100,
    },
    step: {
      type: Number,
      required: false,
      default: () => 1,
    },
    tooltip: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    tooltipFormat: {
      type: [Object, Function],
      required: false,
    },
    tooltipShow: {
      type: String,
      required: false,
      default: () => 'always',
    },
  },

  emits: [
    'update:modelValue',
    'change',
    'input',
  ],

  setup(props, context) {
    const value = computed({
      get(): unknown {
        return props.modelValue;
      },
      set(newValue: unknown): void {
        context.emit('update:modelValue', newValue);
      },
    });

    const emitChange = (val: number) => {
      context.emit('change', val);
    };

    return {
      value,
      emitChange,
    };
  },
});
